import { SectionSchema } from '../types/project';

// Default section properties that are always present
const SECTION_NO = "Section No";
const START_LOCATION = "Start Location";
const END_LOCATION = "End Location";
const TOTAL_DISTANCE = "Total distance";
const RULING_SPAN = "Ruling span";
const MAXIMUM_SAG = "Maximum sag";
const TOTAL_LENGTH_OF_CONDUCTOR = "Total Length of conductor";
const TOTAL_LENGTH_OF_JUMPER_CONDUCTOR = "Total Length of jumper conductor";
const TOTAL_LENGTH_OF_EARTHWIRE_1 = "Total Length of Earthwire-1 (including Earthing connection)";
const TOTAL_LENGTH_OF_EARTHWIRE_2 = "Total Length of Earthwire-2";
const NO_OF_BODY_EXTENSIONS = "No. of body extensions";
const NO_OF_LEG_EXTENSIONS = "No. of leg extensions";
const NO_OF_RAISED_CHIMNEY = "No. of raised chimney";
const TOTAL_MS_STEEL_MEMBERS = "Total MS Steel members";
const TOTAL_HT_STEEL_MEMBERS = "Total HT Steel members";
const TOTAL_MS_STEEL_PLATES = "Total MS Steel plates";
const TOTAL_HT_STEEL_PLATES = "Total HT Steel plates";
const TOTAL_16_DIA_BN = "Total 16 dia B&N";
const TOTAL_20_DIA_BN = "Total 20 dia B&N";
const NUMBER_OF_SOIL_TYPES = "Number of soil types";
const TOTAL_PCC = "Total PCC";
const TOTAL_RCC = "Total RCC";
const TOTAL_EXCAVATION = "Total Excavation";
const TOTAL_REINFORCEMENT_MS_STEEL = "Total Reinforcement MS steel";
const TOTAL_REINFORCEMENT_STEEL = "Total Reinforcement steel";
const TOTAL_TOWER_BASE_OCCUPIED_AREA = "Total tower base occupied area";
const TOTAL_CUTTING_FILLING_VOLUME = "Total cutting+Filling volume";
const TOTAL_FOOTING_AREA = "Total footing area";
const TOTAL_BENCHING_VOLUME = "Total benching volume";
const NO_OF_SOIL_INVESTIGATION_AVAILABLE = "No. of soil investigation availble";
const TOTAL_TERRAIN_TYPES = "Total terrain types";
const RANDOM_RUBBLE = "Random Rubble";
const STONE_BOUND = "Stone Bound";
const BACK_FILLING = "Back Filling";
const M_15_COVER_SEAL = "M-15 Cover seal";
const BIO_ENGINEERING = "Bio-engineering";
const STONE_SOLING = "Stone soling";
const AVIATION_TOTAL_PAINTED_STEEL_WEIGHT = "Aviation: Total painted steel weight";
const AVIATION_LIGHTS = "Aviation: Lights";
const CONDUCTOR_MID_SPAN_COMPRESSION_JOINT = "Conductor:Mid Span Compression Joint for Conductor";
const CONDUCTOR_T_CONNECTOR = "Conductor:T-Connector";
const CONDUCTOR_REPAIR_SLEEVE = "Conductor:Repair Sleeve for Conductor";
const CONDUCTOR_QUAD_SPACER_DAMPER = "Conductor:Quad Spacer Damper for Conductor";
const CONDUCTOR_QUAD_RIGID_SPACER = "Conductor:Quad Rigid Spacer for Conductor";
const CONDUCTOR_INSULATION_SLEEVE = "Conductor:Insulation sleeve";
const NUMBER_OF_BIRD_DIVERTERS = "Number of Bird diverters";
const EARTHWIRE_FLEXIBLE_AL_BOND = "Earthwire:Flexible Al. Bond";
const EARTHWIRE_VIBRATION_DAMPER = "Earthwire:Vibration Damper";
const EARTHWIRE_SUSPENSION_CLAMP = "Earthwire:Suspension Clamp";
const EARTHWIRE_TENSION_CLAMP = "Earthwire:Tension Clamp";
const OPGW_VIBRATION_DAMPER = "OPGW:Vibration damper";
const OPGW_FODP_96F = "OPGW:FODP (96F) including installation";

const NUMBER_OF_POWER_LINE_CROSSINGS = "Number of power line crossings";
const NUMBER_OF_RIVER_CROSSINGS = "Number of river crossings";
const NUMBER_OF_RAILWAY_LINE_CROSSINGS = "Number of railway line crossings";
const NUMBER_OF_HIGHWAY_CROSSINGS = "Number of highway crossings";
const NUMBER_OF_VALLEY_CROSSINGS = "Number of valley crossing?";
const NUMBER_OF_FOREST_CROSSINGS = "Number of forest crossing?";

export const SECTION_PROPERTIES = [
    SECTION_NO,
    START_LOCATION,
    END_LOCATION,
    TOTAL_DISTANCE,
    RULING_SPAN,
    MAXIMUM_SAG,
    TOTAL_LENGTH_OF_CONDUCTOR,
    TOTAL_LENGTH_OF_JUMPER_CONDUCTOR,
    TOTAL_LENGTH_OF_EARTHWIRE_1,
    TOTAL_LENGTH_OF_EARTHWIRE_2,
    NO_OF_BODY_EXTENSIONS,
    NO_OF_LEG_EXTENSIONS,
    NO_OF_RAISED_CHIMNEY,
    TOTAL_MS_STEEL_MEMBERS,
    TOTAL_HT_STEEL_MEMBERS,
    TOTAL_MS_STEEL_PLATES,
    TOTAL_HT_STEEL_PLATES,
    TOTAL_16_DIA_BN,
    TOTAL_20_DIA_BN,
    NUMBER_OF_SOIL_TYPES,
    TOTAL_PCC,
    TOTAL_RCC,
    TOTAL_EXCAVATION,
    TOTAL_REINFORCEMENT_MS_STEEL,
    TOTAL_REINFORCEMENT_STEEL,
    TOTAL_TOWER_BASE_OCCUPIED_AREA,
    TOTAL_CUTTING_FILLING_VOLUME,
    TOTAL_FOOTING_AREA,
    TOTAL_BENCHING_VOLUME,
    NO_OF_SOIL_INVESTIGATION_AVAILABLE,
    TOTAL_TERRAIN_TYPES,
    RANDOM_RUBBLE,
    STONE_BOUND,
    BACK_FILLING,
    M_15_COVER_SEAL,
    BIO_ENGINEERING,
    STONE_SOLING,
    AVIATION_TOTAL_PAINTED_STEEL_WEIGHT,
    AVIATION_LIGHTS,
    CONDUCTOR_MID_SPAN_COMPRESSION_JOINT,
    CONDUCTOR_T_CONNECTOR,
    CONDUCTOR_REPAIR_SLEEVE,
    CONDUCTOR_QUAD_SPACER_DAMPER,
    CONDUCTOR_QUAD_RIGID_SPACER,
    CONDUCTOR_INSULATION_SLEEVE,
    NUMBER_OF_BIRD_DIVERTERS,
    EARTHWIRE_FLEXIBLE_AL_BOND,
    EARTHWIRE_VIBRATION_DAMPER,
    EARTHWIRE_SUSPENSION_CLAMP,
    EARTHWIRE_TENSION_CLAMP,
    OPGW_VIBRATION_DAMPER,
    OPGW_FODP_96F,   
    NUMBER_OF_POWER_LINE_CROSSINGS,
    NUMBER_OF_RIVER_CROSSINGS,
    NUMBER_OF_RAILWAY_LINE_CROSSINGS,
    NUMBER_OF_HIGHWAY_CROSSINGS,
    NUMBER_OF_VALLEY_CROSSINGS,
    NUMBER_OF_FOREST_CROSSINGS
];


/**
 * Gets all section properties including dynamic ones from the schema
 * @param schema The section schema containing property definitions
 * @returns Array of property titles including both static and dynamic properties
 */
export const getAllSectionProperties = (schema: SectionSchema): string[] => {
    if (!schema) return SECTION_PROPERTIES;

    const dynamicProperties = Object.entries(schema)
        .filter(([_, prop]) => (prop as any).isDynamic === true)
        .map(([_, prop]) => prop.title);
    
    return [...SECTION_PROPERTIES, ...dynamicProperties];
};
